export default function sidebarNav() {
  const buttons = document.querySelectorAll(".sidebar-nav button");

  buttons.forEach((el) => {
    const submenu = el.nextElementSibling;

    el.addEventListener("click", (e) => {
      e.preventDefault();

      if (!el.classList.contains("opened")) {
        el.classList.add("opened");
        submenu.style.height = "auto";

        const height = `${submenu.clientHeight}px`;

        submenu.style.height = "0px";

        setTimeout(() => {
          submenu.style.height = height;
        }, 0);
      } else {
        submenu.style.height = "0px";

        setTimeout(() => {
          el.classList.remove("opened");
        }, 0.5);
      }
    });
  });
}
